<template>
  <section id="more">
    <div class="container">
      <div class="more">
        <img src="../assets/client/img/psemarimanga.png" alt="">
      </div>
    </div>
  </section>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
export default {
  name: "WhyUs"
};
</script>
